module.exports = __webpack_public_path__ + "img/signal_cellular_0_bar.582207b3.svg";